module.exports = __webpack_public_path__ + "static/media/20180522-LCS-002-2.343dc285.jpg";